import BaseModel from "scripts/models/baseModel";

class AppUpdateModel extends BaseModel {
  url() {
    return `${process.env.PATRON_UI_CDN_URL}/version.json`;
  }
}

export default AppUpdateModel;
